import ImpactList from "../components/ImpactList";

const ListImpactPage = () => {
  return (
    <ImpactList />
  );
};

export default ListImpactPage;
